import { render, staticRenderFns } from "./DiscountsCard.vue?vue&type=template&id=314dfb5c&"
import script from "./DiscountsCard.vue?vue&type=script&lang=js&"
export * from "./DiscountsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports